var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import LastModifiedButton from './LastModifiedButton';
var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
export var refresh = function () {
    queryClient.invalidateQueries(['ui-change-log']);
};
export default function (props) {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(LastModifiedButton, __assign({}, props))));
}
//# sourceMappingURL=LastModifiedButtonWrapper.js.map